import { updateSettingsBotService } from '../../../services/boteria/updateSettingsBot';

export function updateSettingsBot (config, tokenPartners) {
	return {
		type: 'UPDATE_SETTINGS_BOT',
		payload: updateSettingsBotService(config, tokenPartners)
	}
}